import useSWR from 'swr';

type ApiKey = {
  id: number;
  key_string: string;
  name: string;
  created_at: string;
};

export const useApiKeys = () => {
  const {
    data: apiKeys,
    error: apiKeysError,
    mutate,
  } = useSWR<ApiKey[]>(`${process.env.NEXT_PUBLIC_API_URL}/api_keys`);

  return { apiKeys, apiKeysError, apiKeysMutate: mutate };
};
